import { environment as nonProdConfig } from './environment.non-prod';

export const environment = {
    ...nonProdConfig,
    authCallbackRoute: 'google/class/standalone/auth-callback',
    standalone: true,
    // end lst-auth library required properties
    baseUrl: 'https://stage-google-class.savvasrealizedev.com/google/class/standalone',
    googleUserUrl: 'https://stage.google-user-webapp.savvasrealizedev.com',
    classSyncUrl: 'https://class-sync-service.nightly.savvasrealizedev.com/graphql',
    classMappingUrl: 'https://stage-class-mapping-service.savvasrealizedev.com/graphql',
};
